import { render } from "./area_title.vue?vue&type=template&id=4f00d84b"
import script from "./area_title.vue?vue&type=script&lang=js"
export * from "./area_title.vue?vue&type=script&lang=js"

import exportComponent from "/app/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__